import React from 'react'
import { useIntl } from 'react-intl'
import { RenderLink } from '@molecules/ProductSpecs/ProductSpecs.partials'

const ProductSpecsLinkWrapper = ({
  data,
  regions,
  custom
}: {
  data: any
  regions: Array<any>
  custom?: any
}) => {
  const { formatMessage } = useIntl()
  return (
    <RenderLink
      title={data?.label}
      url={custom?.content?.url}
      icon={data?.type === 'link' ? 'ArrowRightStick' : 'Download'}
      text={
        data?.type === 'link'
          ? formatMessage({
              id: 'msp.productSpecs.links.learnMore',
              defaultMessage: 'Learn more'
            })
          : formatMessage({
              id: 'msp.productSpecs.links.downloadpdf',
              defaultMessage: 'Download PDF'
            })
      }
    />
  )
}

export default ProductSpecsLinkWrapper
